// import React from 'react'
// import Imgage from '../../assets/images/img.png'
// import HomeColumnBetter from "../../components/HomeColumnBetter";
// import './style.css'
// import CardImg from '../../assets/images/SalesImg.png'
// import Squareimg from '../../assets/images/Square.svg'
// import ISD from '../../assets/images/Square Transfer Vertical.png'
// import Selectlocation from '../../assets/images/Paymnet.png'

// const PartnerCard = () => {
//   return (
//     <div className='btn-card'>
//     <div className="flex gap-[35px] self-stretch md:flex-col w-[91%] m-auto">
//     <div className="relative h-[350px] w-full rounded-[26px] border border-solid border-black-900_26 bg-indigo-300 bg-[url(/public/images/img_frame_1171276568.png)] bg-cover bg-no-repeat px-[41px] md:px-5 md:pt-5">
//         <div className="absolute  left-0 right-0 m-auto h-[709px]  md:h-auto" style={{top:0}}>
//           <img src={Imgage} alt="main"  style={{borderRadius:'27px'}} />
         
//         </div>
//       </div>
//       <div className="flex w-full flex-col gap-[35px] pt-4">
//       {[...Array(1)].map((d, index) => (
//                       <HomeColumnBetter
//                         image={Selectlocation}
//                         text="Online Payment"
//                         text1="Secure, fast, and hassle-free in-app payment. Customers pay through the app, so you can say goodbye to handling cash and focus on delivering great service."
//                         key={"listbetter" + index}
//                         className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
//                       />
//                     ))}
//                     <HomeColumnBetter
//                       image={CardImg}
//                       text="Sales Tracking"
//                       text1="Monitor your daily earnings and team performance in real-time. Stay on top of your business with full visibility into every completed wash."
//                       key={"listbetter"}
//                       className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
//                     />
//       </div>
     
//       <div className="flex w-full flex-col gap-[35px]">
//       {[...Array(1)].map((d, index) => (
//                       <HomeColumnBetter
//                         image={Squareimg}
//                         text="Business Insights"
//                         text1="Access valuable data and reports to understand customer trends, peak times, and service performance—helping you make smarter business decisions."
//                         key={"listautomated" + index}
//                         className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
//                       />
//                     ))}
//                     <HomeColumnBetter
//                       image={ISD}
//                       text="Automated Requests"
//                       text1="No more chasing customers or waiting around. Get instant notifications for carwash bookings directly from the app on mobile and desktop."
//                       key={"listbetter"}
//                       className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
//                     />
//       </div>
//     </div>
//     </div>
//   )
// }

// export default PartnerCard
import React from 'react';
import Imgage from '../../assets/images/img.png';
import HomeColumnBetter from "../../components/HomeColumnBetter";
import './style.css'; // You can remove this if it's not used by other components
import CardImg from '../../assets/images/SalesImg.png';
import Squareimg from '../../assets/images/Square.svg';
import ISD from '../../assets/images/Square Transfer Vertical.png';
import Selectlocation from '../../assets/images/Paymnet.png';

// 1. Data ko ek saaf-suthre array mein organize karna
const partnerCardData = [
  {
    image: Selectlocation,
    text: "Online Payment",
    text1: "Secure, fast, and hassle-free in-app payment. Customers pay through the app, so you can say goodbye to handling cash and focus on delivering great service.",
    key: "partner-payment",
  },
  {
    image: Squareimg,
    text: "Business Insights",
    text1: "Access valuable data and reports to understand customer trends, peak times, and service performance—helping you make smarter business decisions.",
    key: "partner-insights",
  },
  {
    image: CardImg,
    text: "Sales Tracking",
    text1: "Monitor your daily earnings and team performance in real-time. Stay on top of your business with full visibility into every completed wash.",
    key: "partner-sales",
  },
  {
    image: ISD,
    text: "Automated Requests",
    text1: "No more chasing customers or waiting around. Get instant notifications for carwash bookings directly from the app on mobile and desktop.",
    key: "partner-requests",
  }
];

const PartnerCard = () => {
  return (
    <div className='btn-card p-4 md:p-8'> {/* Responsive padding */}
      {/* 
        MAIN CONTAINER
        - Mobile First: flex-col (sab kuch ek column mein)
        - Desktop (lg & up): flex-row (side-by-side layout)
      */}
      <div className="flex flex-col lg:flex-row gap-8 self-stretch w-full max-w-7xl mx-auto">
        
        {/* === LEFT SIDE: IMAGE CONTAINER === */}
        {/* 
          - lg:w-2/5: Badi screens par 40% width.
          - h-[400px] md:h-[500px] lg:h-auto: Responsive height.
          - lg:sticky lg:top-8: Badi screens par image scroll ke saath stick rahegi.
        */}
        <div className="relative w-full lg:w-2/5 h-[400px] md:h-[500px] lg:h-auto lg:self-stretch rounded-[26px] overflow-hidden">
          <img 
            src={Imgage} 
            alt="main" 
            className="w-full h-full object-cover" // object-cover image ko stretch kiye bina container ko fill karta hai
          />
        </div>

        {/* === RIGHT SIDE: CARDS GRID === */}
        {/* 
          - lg:w-3/5: Badi screens par bachi hui 60% width.
          - grid: CSS Grid layout enable karega.
          - grid-cols-1: Mobile par 1 column.
          - md:grid-cols-2: Tablet (aur usse upar) par 2 columns.
        */}
        <div className="w-full lg:w-3/5 grid grid-cols-1 md:grid-cols-1 gap-8">
          {partnerCardData.map((card) => (
            <HomeColumnBetter
              key={card.key}
              image={card.image}
              text={card.text}
              text1={card.text1}
              // h-full ensures all cards in a grid row have the same height
              className="flex flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-6 h-full" 
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnerCard;